import { render } from "./ReviewResultsTab.vue?vue&type=template&id=cd30dc8a"
import script from "./ReviewResultsTab.vue?vue&type=script&lang=js"
export * from "./ReviewResultsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__